import './locales/register'
import './page-slots'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const New = lazy(() => import('./components/New'))
const Update = lazy(() => import('./components/Update'))
const UpdateAdvanced = lazy(() => import('./components/UpdateAvanced'))
const Identity = lazy(() => import('./components/Identity'))
const EmployeeConfirmationForm = lazy(() => import('./components/Profile'))
const DepartmentDetail = lazy(() => import('./components/DepartmentDetail'))

const EmployeeModule: RouteObject = {
    path: 'employees',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: ':id/update',
            element: <Update />,
        },
        {
            path: ':id/update-advanced',
            element: <UpdateAdvanced />,
        },
        {
            path: ':id/identity',
            element: <Identity />,
        },
        {
            path: 'departments/:id',
            element: <DepartmentDetail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

// Public onboarding page, mounted by App.tsx under /util (no auth required):
// /util/employee-confirmation
const EmployeePublicModule: RouteObject = {
    path: 'employee-confirmation',
    element: <EmployeeConfirmationForm />,
    errorElement: <ErrorPage status={500} />,
}

export default EmployeeModule
export { EmployeePublicModule }
